import { SanityProductControlOption } from '@gelato-api-ui/core/sanity/sanity-product-control-option';
import { BasePrintAreaCode, printAreaCodesSorted } from '../constants/print-area-code';

export const getSortedPrintSideControlOptions = (
  controlOptions: SanityProductControlOption[],
  sortingOrder = printAreaCodesSorted,
): SanityProductControlOption[] =>
  sortingOrder
    .map((loopPrintSide: BasePrintAreaCode) =>
      controlOptions.find((loopOption: SanityProductControlOption) => loopOption.value === loopPrintSide),
    )
    .filter((loopOption: SanityProductControlOption) => Boolean(loopOption));
